import { render } from "./SubCategoriesPage.vue?vue&type=template&id=3a54beea"
import script from "./SubCategoriesPage.vue?vue&type=script&lang=js"
export * from "./SubCategoriesPage.vue?vue&type=script&lang=js"

import "./SubCategoriesPage.vue?vue&type=style&index=0&id=3a54beea&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__